export default __webpack_public_path__ + "static/media/blog-img226.0f5893cc.jpg";